import { useIdleTimer } from "react-idle-timer";
import { Modal } from "antd";
import { useState, useEffect } from "react";

export const IdleTimeOut = (props: any) => {
	const timeout = 1000 * 60 * 60; // 1000 * 60 * 60 is 1 hour. You can change the timeout value.
	const promptBeforeIdle = 1000 * 5;

	const [prompt, setPrompt] = useState(false);

	useEffect(() => {
		if (!prompt) return;

		let secondsToGo = 5;

		const timer = setInterval(() => {
			secondsToGo -= 1;
			modal.update({
				content: `You will be logged out in ${secondsToGo} seconds.`,
			});
		}, 1000);

		const modal = Modal.success({
			title: "You are about to be timed out",
			content: `You will be logged out in 5 seconds.`,
			onOk() {
				reset();
				setPrompt(false);
			},
		});

		setTimeout(() => {
			clearInterval(timer);
			modal.destroy();
		}, secondsToGo * 1000);
	}, [prompt]);

	const onPrompt = () => {
		setPrompt(true);
	};

	const onIdle = () => {
		window.location.href = "/bff/logout";
	};

	const { reset } = useIdleTimer({
		crossTab: true,
		onIdle,
		onPrompt,
		timeout,
		promptBeforeIdle,
		throttle: 500,
	});

	return props.children;
};
